<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="25.5187mm"
    height="8.4154mm"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 2.45135 0.808392"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="图层_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g>
        <polygon
          class="fil0 str0"
          points="0.492111,0.00967334 0.974606,0.206944 0.974606,0.601448 0.492111,0.798718 0.00962531,0.601448 0.00962531,0.206944 "
        />
      </g>
      <path
        class="fil1"
        d="M0.238654 0.306454l-0.0895096 -0.0300575 0 0.11047 0.0525646 0.0114505c0.0228625,0.00496635 0.0183765,-0.00449565 0.0261382,-0.024265l0.0164649 0.0042459 0.00126801 0.0912772 -0.0164649 -0.0042459c0.00217098,-0.0240249 -0.00433235,-0.0301632 -0.0314504,-0.0370411l-0.0485204 -0.0122958 0 0.0891926c0,0.0190105 0.00351583,0.0269643 0.0164745,0.0294907l0.054188 0.0105955c0.0262343,0.00512005 0.0385493,-0.00745433 0.0450622,-0.0420171l0.0266185 0.00678191 0.00390008 0.0852061 -0.253025 -0.065187 0 -0.0193659 0.0164072 0.00422668c0.0219403,0.00690679 0.0328817,-0.00186358 0.0328817,-0.0264456l0 -0.19974c0.00111431,-0.0242938 -0.0109413,-0.0390584 -0.0361093,-0.0442265l-0.00497596 -0.00128722 0 -0.0194427 0.231718 0.0597019 0.00489911 0.0730928 -0.0214792 -0.00422668c-0.00836691,-0.0332083 -0.0106436,-0.0443033 -0.0270508,-0.0458883z"
      />
      <path
        class="fil1"
        d="M0.768555 0.444417l0 0.07365c-0.00224783,0.0275599 0.0102305,0.0375502 0.0374542,0.0298942l0.0118924 -0.00222862 0 0.0193659 -0.147972 0.0276848 0 -0.0193659 0.00682033 -0.00127761c0.0215561,-0.00146973 0.0317193,-0.0130451 0.0306242,-0.0348509l0 -0.211411c0.0010951,-0.0209029 -0.00906816,-0.0286742 -0.0306242,-0.0233236l-0.00848219 0.00159461 0 -0.0194427c0.00905855,-0.00170028 0.0192218,-0.00417865 0.0306242,-0.00763685 0.011316,-0.00343898 0.0243034,-0.00710851 0.0391064,-0.0112103 0.019241,-0.00491832 0.0422861,-0.0115754 0.0697499,-0.0149471 0.0874539,-0.0107396 0.124024,0.0173582 0.119798,0.0786067 -0.00415944,0.0602879 -0.0406338,0.0945913 -0.109644,0.109558 -0.0171373,0.00371756 -0.033458,0.00626318 -0.0493465,0.00534099zm0 -0.154793l0 0.133448c0.00798267,0.00240152 0.0181459,0.0017387 0.0306242,-0.00183477 0.0408547,-0.00764646 0.0636116,-0.0368106 0.0629968,-0.0874155 -0.000537942,-0.0448797 -0.0225839,-0.0598844 -0.0622187,-0.0545915 -0.0102209,0.00136407 -0.0211718,0.00591736 -0.0314023,0.0103938z"
      />
      <path
        class="fil1"
        d="M0.362035 0.326137l-0.0204226 -0.0217962 0.000336213 -0.0113736 0.11705 0.0276175 0.00150816 0.0165897 -0.0180979 0 -0.00381362 0.104803c-0.000441881,0.012267 0.0590871,0.0275023 0.0943031,0.000768488l0 -0.0874731c0,0 0.000874155,-0.0220652 -0.0172237,-0.0220652l-0.00389047 -0.0126224 0.122161 -0.028655 0 0.0150816c0,0 -0.0226224,0.00904895 -0.0211142,0.0346876l-0.00387126 0.223275c-8.64549e-005,0.00552351 0.0111527,0.0247837 0.0280018,0.0240633l0 0.00904895 -0.124678 0.0281555 -0.00351583 -0.0100576 0.0256387 -0.0211142 0.00150816 -0.117636c0,0 -0.0587605,0.0271468 -0.0994808,0l-0.00307395 0.113112 0.0271468 0.0256387 -0.00150816 0.00754079 -0.117636 -0.0271468 0 -0.0105571c0,0 0.0135734,0 0.0150816,-0.0135734 0.00150816,-0.0135734 0.00559075,-0.24631 0.00559075,-0.24631z"
      />
      <path
        class="fil2"
        d="M1.14624 0.565924l0 -0.120268 0.105437 0 0 0.120268 0.0579152 0 0 -0.274744 -0.0593657 0 0 0.108414 -0.103986 0 0 -0.108414 -0.0579056 0 0 0.274744 0.0579056 0zm0.35824 0.00297789c0.0841494,-0.00195964 0.127684,-0.0485396 0.130662,-0.139586 -0.00297789,-0.0941014 -0.0465127,-0.142065 -0.130662,-0.144091 -0.0851581,0.00202689 -0.129192,0.0499901 -0.13217,0.144091 0.00195964,0.0910466 0.0460036,0.137627 0.13217,0.139586zm0 -0.240594c0.0455617,0 0.068309,0.0336502 0.068309,0.101008 0,0.0663397 -0.0227472,0.0994808 -0.068309,0.0994808 -0.0465704,0 -0.0698267,-0.033141 -0.0698267,-0.0994808 0,-0.067358 0.0232564,-0.101008 0.0698267,-0.101008zm0.251296 0.237616l0 -0.105437 0.0430257 0c0.0613926,-0.00297789 0.0930735,-0.0311718 0.0950428,-0.084649 0.00100864,-0.0574157 -0.0361189,-0.0856768 -0.111392,-0.0846586l-0.0846586 0 0 0.274744 0.0579824 0zm0 -0.228683c0.00392889,0 0.00988468,0 0.0178001,0 0.0396059,-0.00398653 0.0588662,0.00887604 0.0579152,0.0385973 0.000951004,0.0297117 -0.0183092,0.0425742 -0.0579152,0.0385877 -0.00791543,0 -0.0138712,0 -0.0178001,0l0 -0.077185zm0.191853 0.228683l0.188568 0 0 -0.0460612 -0.129202 0 0 -0.072747 0.11583 0 0 -0.0460612 -0.11583 0 0 -0.0638133 0.124764 0 0 -0.0460612 -0.18413 0 0 0.274744zm0.503725 0l0 -0.274744 -0.0549949 0 0 0.215311 -0.00146013 0.00151776 -0.103976 -0.216829 -0.0876364 0 0 0.274744 0.0550045 0 0 -0.227223 0.00145052 -0.00146013 0.106964 0.228683 0.084649 0z"
      />
    </g>
  </svg>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{ color?: string }>(), {
  color: '#FFFFFF',
})
</script>

<style scoped>
.str0 {
  stroke: v-bind('props.color');
  stroke-width: 0.0192122;
  stroke-linejoin: round;
}
.fil0 {
  fill: none;
}
.fil1 {
  fill: v-bind('props.color');
}
.fil2 {
  fill: v-bind('props.color');
  fill-rule: nonzero;
}
</style>
